<!-- ================管理端-听评课====================-->
<template>
    <div class="admin-screen-container">
        <div class="admin-title-container">听评课列表</div>
        <div class="admin-btn-container">
            <div class="admin-btn-item" @click="handleAdd">新增听评课</div>
            <div class="admin-btn-item" @click="handleScaleAdd">新增听评课量表</div>
            <div class="admin-btn-item right-start" @click="resetQuery">重置</div>
            <div class="admin-btn-item" @click="handleQuery">查询</div>
        </div>
        <div class="admin-search4-100">
            <div class="admin-search25">
                <div class="admin-search25-name">学段:</div>
                <div class="admin-search25-item">
                    <el-select clearable @change="changePeriod" v-model="queryParams.periodKey" placeholder="请选择">
                        <el-option v-for="item in periodList" :key="item.dictKey" :label="item.dictValue"
                                   :value="item.dictKey" />
                    </el-select>
                </div>
            </div>
            <div class="admin-search25">
                <div class="admin-search25-name">年级:</div>
                <div class="admin-search25-item">
                    <el-select clearable @change="changeGrade" v-model="queryParams.gradeKey" placeholder="请选择">
                        <el-option v-for="item in gradeList" :key="item.dictKey" :label="item.dictValue"
                                   :value="item.dictKey" />
                    </el-select>
                </div>
            </div>
            <div class="admin-search25">
                <div class="admin-search25-name">学科:</div>
                <div class="admin-search25-item">
                    <el-select clearable @change="getList()" v-model="queryParams.subjectKey" placeholder="请选择">
                        <el-option v-for="item in subjectList" :key="item.dictKey" :label="item.dictValue"
                                   :value="item.dictKey" />
                    </el-select>
                </div>
            </div>
            <div class="admin-search25">
                <div class="admin-search25-name">类型:</div>
                <div class="admin-search25-item">
                    <el-select clearable @change="getList()" v-model="queryParams.type" placeholder="请选择">
                        <el-option v-for="item in typeList" :key="item.value" :label="item.name"
                                   :value="item.value" />
                    </el-select>
                </div>
            </div>
        </div>
        <div class="admin-search4-100 mt5">
            <div class="admin-search25">
                <div class="admin-search25-name">听评课状态:</div>
                <div class="admin-search25-item">
                    <el-select clearable @change="getList()" v-model="queryParams.status" placeholder="请选择">
                        <el-option v-for="item in statusList" :key="item.value" :label="item.name"
                                   :value="item.value" />
                    </el-select>
                </div>
            </div>
            <div class="admin-search25">
                <div class="admin-search25-name">所属机构:</div>
                <div class="admin-search25-item">
                    <el-select clearable @change="getList()" v-model="queryParams.orgId" placeholder="请选择">
                        <el-option v-for="item in orgList" :key="item.orgId" :label="item.orgName"
                                   :value="item.orgId" />
                    </el-select>
                </div>
            </div>
            <div class="admin-search25"></div>
            <div class="admin-search25">
                <div class="admin-search25-item-input">
                    <el-input class="admin-input1" v-model="queryParams.title" placeholder="请输入听评课名称">
                        <template #append>
                            <el-button @click="handleQuery" class="name-search-btn" type="primary"
                                       icon="el-icon-search" />
                        </template>
                    </el-input>
                </div>
            </div>
        </div>
        <!--数据列表-->
        <div class="mt5">
            <el-table v-loading="loading"
                      cell-class-name="admin-table"
                      show-overflow-tooltip
                      height="calc(100vh - 310px)"
                      :data="dataList"
                      class="admin-table"
                      highlight-current-row>
                <el-table-column type="index" fixed="left" align="center" label="序号" width="60" />
                <el-table-column width="100" align="center" label="任务状态" prop="status">
                    <template #default="scope">
                        <div v-if="scope.row.status == 0">未提请</div>
                        <div v-if="scope.row.status == 1">初始</div>
                        <div v-if="scope.row.status == 2">进行中</div>
                        <div v-if="scope.row.status == 3">已结束</div>
                    </template>
                </el-table-column>
                <el-table-column width="220" align="center" label="课程标题" prop="title">
                    <template #default="scope">
                        <div :title="scope.row.title" @click="goDetail(scope.row)" style="color: #377f7f;"
                             class="text-one cursor">
                            {{ scope.row.title }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="120" align="center" label="听评课性质" prop="lessonNature">
                    <template #default="scope">
                        <div v-if="scope.row.lessonNature == 1 || scope.row.lessonNature == null || scope.row.lessonNature == ''">普通</div>
                        <div v-if="scope.row.lessonNature == 2">名师工作室</div>
                        <div v-if="scope.row.lessonNature == 3">名校长工作室</div>
                        <div v-if="scope.row.lessonNature == 4">群组任务</div>
                    </template>
                </el-table-column>
                <el-table-column width="100" align="center" label="类型" prop="type">
                    <template #default="scope">
                        <div v-if="scope.row.type == 0">推门</div>
                        <div v-if="scope.row.type == 1">线上</div>
                        <div v-if="scope.row.type == 2">录播视频</div>
                    </template>
                </el-table-column>
                <el-table-column width="120" align="center" label="授课老师" prop="lectureTeacherName" />
                <el-table-column min-width="180" align="center" label="听课地点" prop="address" />
                <el-table-column width="260" align="center" label="任务时段" prop="time">
                    <template #default="scope">
                        <div>
                            {{ timestampToTime(scope.row.beginTime) }}至{{ timestampToTime(scope.row.endTime) }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column width="160" align="center" label="评课截止时间" prop="rateEndTime">
                    <template #default="scope">
                        <div>{{ timestampToTime(scope.row.rateEndTime) }}</div>
                    </template>
                </el-table-column>
                <el-table-column width="180" align="center" label="学段·年级·学科">
                    <template #default="scope">
                        <el-text>
                            {{ scope.row.periodName || '--' }}•{{ scope.row.gradeName || '--' }}•{{ scope.row.subjectName || '--' }}
                        </el-text>
                    </template>
                </el-table-column>
                <el-table-column width="160" align="center" label="发布时间" prop="releaseTime">
                    <template #default="scope">
                        <div>{{ timestampToTime(scope.row.releaseTime) }}</div>
                    </template>
                </el-table-column>
                <el-table-column width="120" fixed="right" align="center" label="操作"
                                 class-name="small-padding fixed-width">
                    <template #default="scope">
                        <el-popover placement="bottom" trigger="click" :width="100" popper-style="padding: 5px 0 0">
                            <template #reference>
                                <el-button type="primary" size="default">操作</el-button>
                            </template>
                            <template #default>
                                <div>
                                    <div class="text-item" v-if="scope.row.status != 3">
                                        <el-text type="primary" @click="handleUpdate(scope.row)">编辑</el-text>
                                    </div>
                                    <div class="text-item" v-if="scope.row.status == 1">
                                        <el-text type="primary" @click="handleRelease(scope.row)">发布任务</el-text>
                                    </div>
                                    <div class="text-item" v-if="scope.row.status == 2">
                                        <el-text type="primary" @click="handleStop(scope.row)">停止评课</el-text>
                                    </div>
                                    <div class="text-item">
                                        <el-popconfirm
                                            confirm-button-text="是"
                                            cancel-button-text="否"
                                            icon-color="#626AEF"
                                            title="确定删除该听评课"
                                            @confirm="handleDelete(scope.row)">
                                            <template #reference>
                                                <el-text type="danger">删除</el-text>
                                            </template>
                                        </el-popconfirm>
                                    </div>
                                </div>
                            </template>
                        </el-popover>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <!--  分页  -->
        <div>
            <pagination :background="false"
                        :pageSizes="[10, 20, 30]"
                        :total="total"
                        v-model:page="queryParams.pageNum"
                        v-model:limit="queryParams.pageSize"
                        @pagination="getList" />
        </div>
    </div>
</template>
<script>
import { evaluationPageLessons, evaluationDel, evaluationRelease, evaluationStop } from "@/api/admin/evaluation";
import { queryDict } from "@/api/admin/dict";
import { queryUserManagerOrg } from "@/api/admin/org";
import { timestampToTime } from "@/utils/date";

export default {
    components: {},
    name: "evaLessonIndex",
    data() {
        return {
            timestampToTime,
            role: this.$storage.get("role"),
            userId: '',
            loading: false,
            total: 0,
            dataList: [],
            queryParams: {
                status: '',
                type: '',
                orgId: '',
                periodKey: '',
                gradeKey: '',
                subjectKey: '',
                title: '',
                pageNum: 1,
                pageSize: 10,
            },
            statusList: [
                { name: '初始', value: 1 },
                { name: '进行中', value: 2 },
                { name: '已结束', value: 3 },
            ],
            typeList: [
                { name: '推门', value: 0 },
                { name: '线上', value: 1 },
            ],
            periodList: [],
            gradeList: [],
            subjectList: [],
            orgList: [],
        }
    },
    computed: {},
    watch: {},
    created() {
        this.initUserId();
        this.getQueryDict();
        this.queryUserManagerOrg();
        this.getList();
    },
    mounted() {},
    methods: {
        initUserId() {
            const userInfo = this.$storage.get("userInfo");
            if (userInfo) {
                try {
                    this.userId = JSON.parse(userInfo).userId;
                } catch (e) {
                    this.userId = '';
                }
            }
        },
        getQueryDict() {
            queryDict({ code: 'lession_xd_nj_xk' }).then(res => {
                if (res.data && res.data.code == 1) {
                    this.periodList = res.data.data;
                }
            })
        },
        queryUserManagerOrg() {
            queryUserManagerOrg().then(res => {
                if (res.data && res.data.code === 1) {
                    this.orgList = res.data.data || [];
                }
            })
        },
        changePeriod() {
            this.queryParams.gradeKey = '';
            this.queryParams.subjectKey = '';
            this.gradeList = [];
            this.subjectList = [];
            this.periodList.forEach(j => {
                if (this.queryParams.periodKey === j.dictKey) {
                    this.gradeList = j.childrenList;
                }
            })
            this.getList();
        },
        changeGrade() {
            this.queryParams.subjectKey = '';
            this.subjectList = [];
            this.periodList.forEach(e => {
                if (this.queryParams.periodKey === e.dictKey) {
                    e.childrenList.forEach(j => {
                        if (this.queryParams.gradeKey === j.dictKey) {
                            this.subjectList = j.childrenList;
                        }
                    })
                }
            })
            this.getList();
        },
        /** 查询听评课列表 */
        getList(e) {
            this.loading = true;
            this.dataList = [];
            if (e) {
                this.queryParams.pageNum = e.page;
                this.queryParams.pageSize = e.limit;
            }
            evaluationPageLessons(this.queryParams).then(res => {
                if (res.data && res.data.code == 1) {
                    this.total = res.data.data.total;
                    const list = res.data.data.list || [];
                    list.forEach(e => {
                        e.isCreate = e.createUser == this.userId;
                    })
                    this.dataList = list;
                }
                this.loading = false;
            }).catch(() => {
                this.loading = false;
            })
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置查询条件 */
        resetQuery() {
            this.queryParams = {
                status: '',
                type: '',
                orgId: '',
                periodKey: '',
                gradeKey: '',
                subjectKey: '',
                title: '',
                pageNum: 1,
                pageSize: 10,
            };
            this.gradeList = [];
            this.subjectList = [];
            this.getList();
        },
        /** 新增听评课 */
        handleAdd() {
            this.$router.push({
                path: "/evaLessonCreate",
            });
        },
        /** 编辑听评课 */
        handleUpdate(row) {
            this.$router.push({
                path: "/evaLessonCreate",
                query: {
                    lessonId: row.lessonId,
                }
            });
        },
        /** 听评课详情 */
        goDetail(row) {
            this.$router.push({
                path: "/evaLessonDetail",
                query: {
                    lessonId: row.lessonId,
                }
            });
        },
        /** 新增听评课量表 */
        handleScaleAdd() {
            this.$router.push({
                path: "/evaLessonScale",
            });
        },
        /** 发布听评课 */
        handleRelease(row) {
            if (!row.scaleList || row.scaleList.length == 0) {
                this.$message.error("听评课量表不能为空")
                return
            }
            this.$confirm('确定发布该听评课?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                evaluationRelease({ lessonId: row.lessonId }).then(res => {
                    if (res.data && res.data.code == 1) {
                        this.$message.success("发布成功");
                        this.getList();
                    } else {
                        this.$message.error(res.data.msg || "发布失败");
                    }
                })
            });
        },
        /** 停止听评课 */
        handleStop(row) {
            this.$confirm('确定停止该听评课?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                evaluationStop({ lessonId: row.lessonId }).then(res => {
                    if (res.data && res.data.code == 1) {
                        this.$message.success("停止成功");
                        this.getList();
                    } else {
                        this.$message.error(res.data.msg || "停止失败");
                    }
                })
            });
        },
        /** 删除听评课 */
        handleDelete(row) {
            evaluationDel({ lessonId: row.lessonId }).then(res => {
                if (res.data && res.data.code == 1) {
                    this.$message.success("删除成功");
                    this.getList();
                } else {
                    this.$message.error(res.data.msg || "删除失败");
                }
            })
        },
    }
}
</script>
<style scoped>
.name-search-btn {
    background-color: #377f7f !important;
    color: #fff !important;
}
</style>
